import React, { Fragment } from "react";
import { ErrorMessage, Field } from "formik";
import { AGB, PRIVACY } from "./field-names";
import { withNamespace } from "../../../../util/forms/with-namespace";
var LegalAgreementForm = function LegalAgreementForm(_ref) {
    var namespace = _ref.namespace, privacyNonSubscription = _ref.privacyNonSubscription;
    return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkbox-field text-left mb-4"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement(Field, {
        type: "checkbox",
        name: withNamespace(AGB, namespace)
    }), /*#__PURE__*/ React.createElement("span", null, "Die ", /*#__PURE__*/ React.createElement("a", {
        href: "/agb",
        target: "_blank",
        className: "text-makroOrange"
    }, "AGB"), " habe ich zur Kenntnis genommen.")), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(AGB, namespace),
        component: "div",
        className: "error-message"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "checkbox-field text-left"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement(Field, {
        type: "checkbox",
        name: withNamespace(PRIVACY, namespace)
    }), privacyNonSubscription ? /*#__PURE__*/ React.createElement("span", null, "Ich stimme der ", /*#__PURE__*/ React.createElement("a", {
        href: "/datenschutz",
        target: "_blank",
        className: "text-makroOrange"
    }, "Datenschutzerkl\xE4rung"), " zu.") : /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("span", {
        className: "block mb-2"
    }, "Ich stimme zu, dass meine Angaben aus dem obigen Formular zur Erstellung und zur Verwaltung meiner Abonnements erhoben und verarbeitet werden."), "Hinweis: Sie k\xF6nnen Ihre Einwilligung jederzeit f\xFCr die Zukunft per E-Mail an aboservice@makroskop.eu widerrufen. Detaillierte Informationen zum Umgang mit Nutzerdaten finden Sie in unserer ", /*#__PURE__*/ React.createElement("a", {
        href: "/datenschutz",
        target: "_blank",
        className: "text-makroOrange"
    }, "Datenschutzerkl\xE4rung"), ".")), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(PRIVACY, namespace),
        component: "div",
        className: "error-message"
    })));
};
export default LegalAgreementForm;
